<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col m-0 p-0">
                <audio-buttons-segment
                    v-model="sharedState.currentPage.data"
                    :audio-items="items"
                    :audio-items-array="itemsArray"
                    :button-type="minibuttonType"
                ></audio-buttons-segment>
            </div>
        </div>
    </div>
</template>

<script>
import AudioButtonsSegment from '@/components/AudioButtonsSegment.vue'
import Global from '@/mixins/global'
import store from '../store/store'
import moji from 'moji'

export default {
    name: 'MainButtons',
    props: {
        searchWord: {
            type: String,
            default: ''
        }
    },

    components: {
        AudioButtonsSegment,
    },
    mixins: [Global],
    data: function () {
        return {
            sharedState: store.state,
        }
    },
    computed: {
        minibuttonType: function() {
            return store.getMiniButtonType()
        },
        itemsArray: function() {
            return store.getItems()
        },
        items: function () {
            let filteredItems = []
            if (this.searchWord === '') {
                filteredItems = store.getNowPageItems()
            } else {
                const search = moji(this.searchWord)
                    .convert('HK', 'ZK')
                    .convert('KK', 'HG')
                    .toString()
                filteredItems = store.getItems().filter(function (item) {
                    return item.searchWord.indexOf(search) > -1
                }, this)
            }
            const itemsOfItems = this.splitArrayByKey(filteredItems, 'videoId')
            return itemsOfItems
        },
    },

}
</script>

